import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { } from "../../store/actions";

import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import flamingosm from "../../assets/images/brands/favicon.svg";
import flamingolg from "../../assets/images/brands/flamingo-logo.svg";



class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
           <React.Fragment>
        <div className="vertical-menu">
          <div className="navbar-brand-box">
            <span  className="logo logo-dark float-left" >
              <span className="logo-sm">
                <img src={flamingosm} alt="" height="50" width="30px" style={{marginBottom:"5px"}} />
              </span>
              <span className="logo-lg">
                <img src={flamingolg} alt="" height="50" width="160" style={{marginBottom:"5px"}}/>
              </span>
            </span>
            <span className="logo logo-light">
            <span className="logo-sm">
                <img src={flamingosm} alt="" height="50" width="30px" style={{marginBottom:"5px"}} />
              </span>
              <span className="logo-lg">
                <img src={flamingolg} alt="" height="50" width="160" style={{marginBottom:"5px"}}/>
              </span>
            </span>
 
          </div>
          <div data-simplebar className="h-100">
            {this.props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
          </div>
          <div className="sidebar-background"></div>
        </div>
      </React.Fragment>
    );
  }
}

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
